module.exports = __webpack_public_path__ + "static/about-1-a55bd67452027ae31f7784ae47bc6284.png";